import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';

const state = {
    briefId: 0,
    briefEntregaId: 0,

    id: 0,
    cambios: '',
    fechaEntrega: '1900-01-01',
    fechaEntregaHabilitada: false,
    imagenes: [],
    uploadingFiles: false,
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, params) {
        state.briefId = params.briefId;
        state.briefEntregaId = params.briefEntregaId;

        state.id = 0;
        state.cambios = '';
        state.fechaEntrega = moment(new Date()).format('YYYY-MM-DD hh:mm');
        state.fechaEntregaHabilitada = false;
        state.imagenes = [];
        state.uploadingFiles = false;
    },
    'SET_UPLOADING'(state) {
        state.uploadingFiles = true;
    },
    'SET_IMAGEN'(state, params) {
        state.imagenes.push({
            id: helpers.methods.getUUID(),
            imagenId: 0,
            publicId: params.publicId,
            fileName: params.fileName,
            url: params.url
        });

        state.uploadingFiles = false;
    },
    'DELETE_IMAGEN'(state, imagenId) {
        let itemKey = state.imagenes
            .findIndex(imagen => imagen.id == imagenId);

        if (itemKey != -1) {
            state.imagenes.splice(itemKey, 1);
        }
    },
    'SET_BRIEF_CAMBIO_ID'(state, params) {
        state.id = params.id;
    },
};

const getters = {
    getField,

    briefId(state) {
        return state.briefId;
    },
    briefCambio(state) {
        return {
            id: state.id,
            cambios: state.cambios.trim(),
            fechaEntrega: helpers.methods.getConditionalDateTime(state.fechaEntregaHabilitada, state.fechaEntrega),
            imagenes: state.imagenes.map(imagen => ({
                id: imagen.imagenId,
                publicId: imagen.publicId,
                fileName: imagen.fileName,
                url: imagen.url
            }))
        };
    }
};

const actions = {
    async inicializar ( { commit }, briefId ) {
        commit('INICIALIZAR', briefId);
    },    

    async save ( { state, commit } ) {
        try {
            let imagenes = [];
            if (state.imagenes) {
                imagenes = state.imagenes.map(imagen => ({
                    id: imagen.imagenId,
                    publicId: imagen.publicId,
                    fileName: imagen.fileName,
                    url: imagen.url
                }))
            }

            let briefCambios = {
                cambios: state.cambios.trim(),
                fechaEntrega: helpers.methods.getConditionalDateTime(state.fechaEntregaHabilitada, state.fechaEntrega),

                imagenes
            }
            
            if (state.briefEntregaId == 0) {
                const res = await apiAxios.post(`briefs/${state.briefId}/cambios`, briefCambios);
                commit('SET_BRIEF_CAMBIO_ID', { id: res.data.id });
            } else {
                const res = await apiAxios.post(`briefs/${state.briefId}/originales/${state.briefEntregaId}/cambios/add`, briefCambios);
                commit('SET_BRIEF_CAMBIO_ID', { id: res.data.id });
            }

        } catch(error) {
            const errorMessage = helpers.methods.getErrorMessage(error);
            throw new Error(errorMessage);
        }
    },
    uploadImagen ( { commit }, file ) {
        return new Promise((resolve, reject) => {
            let upload = true;
            let errorMessage = '';

            /* Validamos los archivos a subir */
            let fileName = file.name;
            let fileExtension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase();
            let fileSize = parseFloat(file.size / 1048576);

            if (fileExtension != 'jpg' 
                && fileExtension != 'png'
                && fileExtension != 'jpeg'
                && fileExtension != 'pdf'
                && fileExtension != 'ppt'
                && fileExtension != 'pptx'
                && fileExtension != 'doc'
                && fileExtension != 'docx'
                && fileExtension != 'xls'
                && fileExtension != 'xlsx'
                && fileExtension != 'zip'
                && fileExtension != 'rar'
                && fileExtension != 'ai'
                && fileExtension != 'psd') {
                    upload = false;
                    errorMessage = 'El tipo de archivo seleccionado no es válido.';
            }

            if (fileSize >= 10 ) {
                upload = false;
                errorMessage = 'El archivo seleccionado tiene un peso mayor al permitido. Sólo se permiten imágenes o documentos de hasta 10MB.';
            }

            if (upload) {
                commit('SET_UPLOADING');
    
                let formData = new FormData();
                formData.append('file', file);
                
                let options = {
                    headers: { 'Content-Type': 'multipart/form-data' },
                }
                apiAxios.post(`briefs/${state.briefId}/imagenes`, formData, options)
                    .then(res => {
                        commit('SET_IMAGEN', {
                            publicId: res.data.publicId,
                            fileName: res.data.fileName,
                            url: res.data.url
                        });
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    deleteImagen ( { commit }, imagenId) {
        return new Promise((resolve, reject) => {
            commit('DELETE_IMAGEN', imagenId);
            resolve();
        })
    },
    cancel ( { state } ) {
        return new Promise((resolve, reject) => {
            let promises = [];

            /* Verifico si hay imagenes pendientes y las cancelo */
            state.imagenes
                .filter(t => t.imagenId == 0 && t.publicId != '')
                .forEach(imagen => {
                    let file = {
                        publicId: imagen.publicId
                    }
                    promises.push(apiAxios.post(`briefs/${state.briefId}/imagenes/delete`, file));
                });

            if (promises.length != 0) {
                Promise.all(promises)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}